import React from 'react';
import { useTranslation } from 'react-i18next';
import EmailDefaultIcon from 'components/atoms/icons/emailDefaultIcon';
import TelephoneIcon from 'components/atoms/icons/telephoneIcon';
import PersonCheckIcon from 'components/atoms/icons/personCheckIcon';
import {
  numberTypesDataSource,
  type INumberTypeItem,
} from 'infrastructure/data-sources/number-types';

import s from './styles.module.scss';

import type { IPatientDetails } from 'infrastructure/hooks/smsDashboard/usePatientInfo';

interface IProps {
  patientInfo: IPatientDetails | undefined;
}

const SmsDashboardContactInfo: React.FC<IProps> = ({ patientInfo }) => {
  const { t } = useTranslation();

  const numberTypes = numberTypesDataSource();

  const cutText = (text?: string) =>
    text && text?.length > 27 ? `${text.slice(0, 27)}...` : text;

  const findNumberType = (tp?: string) =>
    numberTypes.find((type: INumberTypeItem) => type.id === tp)?.name;

  const contactMethod = patientInfo?.profile.preferredContactMethod
    ? cutText(
        patientInfo?.profile[
          patientInfo?.profile
            .preferredContactMethod as keyof typeof patientInfo.profile
        ] as string,
      )
    : '-';

  const a = (label: string, value: any) => (
    <div className={s.col}>
      <p>{label}:</p>
      <p>{value}</p>
    </div>
  );

  return (
    <div className={s.wrapper}>
      <div className={s.item}>
        <div className={s.icon}>
          <EmailDefaultIcon />
        </div>
        <div className={s.text}>{cutText(patientInfo?.profile.email)}</div>
      </div>
      <div className={s.item}>
        <div className={s.icon}>
          <TelephoneIcon />
        </div>
        <div className={s.phone}>
          {a(t('smsDashboard.primary'), patientInfo?.profile.phone)}
          {a(
            t('smsDashboard.type'),
            findNumberType(patientInfo?.profile.primaryNumberType),
          )}
          {a(t('smsDashboard.secondary'), patientInfo?.profile.phone)}
          {a(
            t('smsDashboard.type'),
            findNumberType(patientInfo?.profile.secondaryNumberType),
          )}
        </div>
      </div>
      <div className={s.item}>
        <div className={s.icon}>
          <PersonCheckIcon />
        </div>
        <div>
          {a(t('smsDashboard.preferred_contact_method'), contactMethod)}
        </div>
      </div>
    </div>
  );
};

export default SmsDashboardContactInfo;
